var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _path2, _path3, _path4, _path5, _path6, _rect12, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoServerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 212,
    viewBox: "0 0 400 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.814 168.652C179.302 179.504 178.93 199.954 149.535 194.931C141.116 193.492 134.926 191.269 130.438 188.672C117.116 180.964 136.464 165.292 136.781 180.68C136.819 182.536 136.665 184.641 136.279 187.024C133.116 206.559 108.605 203.536 96.7441 199.582",
    stroke: "black",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.33691,
    y: 104.686,
    width: 74.814,
    height: 106.442,
    rx: 9.5,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44141,
    y: 111.627,
    width: 94.4186,
    height: 28.3721,
    rx: 10,
    fill: "#F4780B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44141,
    y: 147.441,
    width: 94.4186,
    height: 28.3721,
    rx: 10,
    fill: "#F4780B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44141,
    y: 183.256,
    width: 94.4186,
    height: 28.3721,
    rx: 10,
    fill: "#F4780B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 247.907,
    y: 169.768,
    width: 53.0233,
    height: 32.5581,
    fill: "#0059FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230.232,
    y: 200,
    width: 88.3721,
    height: 11.6279,
    rx: 5.81395,
    fill: "#0059FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154.884,
    width: 245.116,
    height: 171.628,
    rx: 28,
    fill: "#146DFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143.325,
    y: 1,
    width: 243.116,
    height: 169.628,
    rx: 27,
    fill: "white",
    stroke: "#262527",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 239.604,
    y: 170.768,
    width: 51.0233,
    height: 30.5581,
    fill: "white",
    stroke: "#262527",
    strokeWidth: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 221.931,
    y: 201,
    width: 86.3721,
    height: 9.62791,
    rx: 4.81395,
    fill: "white",
    stroke: "#262527",
    strokeWidth: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 112.127,
    width: 93.4186,
    height: 27.3721,
    rx: 9.5,
    fill: "white",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 147.941,
    width: 93.4186,
    height: 27.3721,
    rx: 9.5,
    fill: "white",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 183.756,
    width: 93.4186,
    height: 27.3721,
    rx: 9.5,
    fill: "white",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.59941,
    cy: 194.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9998,
    cy: 194.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.59941,
    cy: 199.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9998,
    cy: 199.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3992,
    cy: 199.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7996,
    cy: 199.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.199,
    cy: 199.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.8006,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.201,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6004,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0008,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.4002,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.8006,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.201,
    cy: 159.526,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6004,
    cy: 164.639,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0008,
    cy: 164.639,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.4002,
    cy: 164.639,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.8006,
    cy: 164.639,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.201,
    cy: 164.639,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.4002,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8006,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6004,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9998,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.4002,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.8006,
    cy: 122.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.4002,
    cy: 127.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8006,
    cy: 127.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2,
    cy: 127.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6004,
    cy: 127.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9998,
    cy: 127.913,
    rx: 1.2,
    ry: 1.2,
    fill: "#146DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.815 51.1641L225.118 60.4664",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.118 51.1641L215.816 60.4664",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.116 51.1641L314.419 60.4664",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M314.419 51.1641L305.117 60.4664",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.604 96.2796V96.2796C255.964 91.5591 274.269 91.5591 291.628 96.2796V96.2796",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 173.488,
    width: 2.7907,
    height: 85.5814,
    fill: "#262527"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.768 95.8145H180V90.2331C180 87.4074 177.709 85.1168 174.884 85.1168C172.058 85.1168 169.768 87.4074 169.768 90.2331V95.8145Z",
    fill: "#146DFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.628 95.8145H173.488V99.0703C173.488 99.584 173.072 100 172.558 100C172.044 100 171.628 99.584 171.628 99.0703V95.8145Z",
    fill: "#FE7711"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.279 95.8145H178.14V99.0703C178.14 99.584 177.723 100 177.21 100C176.696 100 176.279 99.584 176.279 99.0703V95.8145Z",
    fill: "#FE7711"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoServerIcon);
export default __webpack_public_path__ + "static/media/NoServerIcon.2e8bb6ac422ced6edd85b78bdd32d564.svg";
export { ForwardRef as ReactComponent };